<template>
  <div class="panel-admin-body">
    <div class="d-flex title">
      <div class="pb-1"><modal-link modal-id="How to Use"></modal-link>{{ title }}</div>
      <div class="ml-auto">
        <i v-show="this.$parent.displayShowMenuIcon && this.$root.getShowHeaderMenu()" class="fa fa-window-minimize pl-1 pr-1" aria-hidden="true" @click="$parent.toggleHeaderMenu()"></i>
        <i v-show="this.$parent.displayShowMenuIcon && !this.$root.getShowHeaderMenu()" class="fa fa-window-maximize pl-1 pr-1" aria-hidden="true" @click="$parent.toggleHeaderMenu()"></i>
      </div>
    </div>
    <respondent-menu></respondent-menu>
    <div v-if="!permissionToView" class="no-permission text-center">You do not have permission to view this page</div>   
    <div v-else>
      <div class="pl-3">
        To modify collection dates, click
        <router-link :to="{ name: 'respondent-waves' }">here</router-link>
      </div>
      <div class="respondent-download">
        <div>
          <a
            href="#"
            @click.prevent="downloadItem()"
            id="DownloadCompleteSurveyData"
            :class="[this.disableDownloadButton ? 'btn btn-primary float-right mb-4' : 'btn btn-primary float-right mb-4 disabled']"
            role="button"
            aria-disabled="true"
          >
            <span class="align-text-bottom">Download Survey Data <font-awesome-icon :icon="['fa', 'download']"/></span>
            <span v-show="getModalLoading()" class="mb-1 align-text-bottom spinner-border spinner-border-sm"></span>
          </a>
          <div class="form-group p-2 float-right">
            <input
              type="checkbox"
              class="form-check-input"
              id="includeQualityGrades"
              name="includeQualityGrades"
              v-model="includeQualityGrades"
            />
            <label class="custom-checkout" for="includeQualityGrades">Include Quality Grades</label>
          </div>            
        </div>      
        <table :id="table.id" :class="table.class" cellspacing="0" width="100%">
          <thead></thead>
          <tbody></tbody>
        </table>
        <div v-for="(pageContent, idxPageContent) in pageContent" v-bind:key="idxPageContent">
          <modal :modal-id="pageContent.title" :modal-title="pageContent.title" :modal-content="pageContent.contentText" />
        </div>
      </div>
    </div>   
    
  </div>
</template>
<script>
import $ from "jquery";
import jQuery from "jquery";

import RespondentMixins from "../../mixins/RespondentMixins.vue";
import DataTableMixins from "../../mixins/DataTableMixins.vue";

import AdminService from "../../services/admin.service";
import UserSettingsService from "../../services/user.settings.service";
import UserService from "../../services/user.service";
import SurveySummaryService from "../../services/survey.summary.service";

export default {
  name: "RespondentDownload",
  mixins: [RespondentMixins, DataTableMixins],
  components: {},
  props: {},
  data() {
    return {
      table: {
        id: "respondent-download-data",
        configuration: {
          dom: '<"top"if>rt<"bottom"lp><"clear">',
          searching: false,
          paging: true,
          select: true,
          destroy: true,
          info: false,
          ordering: true,
          keys: true,
          bSort: false
        },
        columns: SurveySummaryService.getRespondentDownloadTableColumnData()
      },
      pageNumber: 5,
      clientTimePeriods: [],
      downloadSets: [],
      includeQualityGrades: true,
      disableDownloadButton: false,
      title: "Download"
    };
  },
  methods: {
    async getTableData() {
      if (!this.isW5OUser){
        this.$root.processServerRequest();
        SurveySummaryService.getSummaryDataBySurveyId(this.getTableDataCallback, this);
      }
    },
    loadData: function() {
      this.downloadSets = [];
      this.clientTimePeriods = [];
      this.getTableData();
      this.table.configuration.order = [
        [1, "desc"],
        [8, "desc"]
      ];
    },
    async downloadItem() {
      this.setupDownloadItem();
      await SurveySummaryService.getDownloadSurveyDataUrlMultiple(this.downloadSets, this.includeQualityGrades, this.downloadItemCallback, this);
    },
    processUserSettings: function (response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        let userSettings = response.data.data;
        var inputIncludeQualityGrades = userSettings.find((x) => x.userSettingTypeName == "include-quality-grades");
        if (typeof inputIncludeQualityGrades != "undefined") {
          this.includeQualityGrades = inputIncludeQualityGrades.userSettingValue == "Y" ? true : false;
        }        
      }
    }    
  },
  created() {},
  mounted() {
    UserSettingsService.getUserSettingsFromDatabase(UserService.getUserId(),  UserService.getUserCode(), this.processUserSettings, this);
    let vm = this;
    $("#respondent-download-data tbody").on("click", 'input[type="checkbox"]', function(e, dt, type, indexes) {
      var $row = $(this).closest("tr");
      var data = vm.table.dataTable.row($row).data();
      if (!jQuery.isEmptyObject(data)) {
        if (e.target.checked) {
          let downloadSet = new Object();
          downloadSet.id = data.id;
          downloadSet.surveyId = data.surveyId;
          vm.downloadSets.push(downloadSet);
          vm.clientTimePeriods.push(data.id);
          vm.disableDownloadButton = true;
        } else {
          let removedItem = vm.clientTimePeriods.find(x => x == data.id);
          if (typeof removedItem !== "undefined") {
            vm.clientTimePeriods.splice($.inArray(removedItem, vm.clientTimePeriods), 1);
            vm.downloadSets.splice($.inArray(removedItem, vm.downloadSets), 1);
            vm.disableDownloadButton = false;
          }
        }
      }
    });
  },
  watch: {},
  computed: {}
};
</script>
